﻿import * as $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import { Loader } from './loader';
import tinymce from 'tinymce/tinymce';

export class OrganizationEditWidget {
    private element: HTMLElement;
    private loader: Loader;
    private formElement: HTMLFormElement;
    private formAction: string;
    private notificationElement: HTMLElement;
    private notificationMessageElement: HTMLElement;

    constructor(element: HTMLElement) {
        this.element = element;
    }

    public init(): void {
        this.loader = new Loader();
        this.formElement = this.element.querySelector('form')!;
        this.formAction = this.formElement.getAttribute('action')!;

        this.notificationElement = this.element.querySelector('.notification')!;
        if (this.notificationElement) {
            this.notificationMessageElement = this.notificationElement.querySelector('.notification-message')!;
            this.hideNotification();
        }

        this.initializeFormValidation();
        this.setupEventListeners();
        this.initializeTinyMCE();
        this.setupImagePreview();
    }

    private initializeFormValidation(): void {
        const form = $(this.formElement);
        $.validator.messages.required = 'Polje je obvezno.';
        form.validate({
            rules: {
                MainAdminTaxNumber: {
                    required: function () {
                        return $('#Active').is(':checked');
                    }
                },
                TaxNumber: {
                    required: function () {
                        return $('#Active').is(':checked');
                    }
                },
                BankAccountNumber: {
                    required: function () {
                        return $('#Active').is(':checked');
                    }
                },
                BankBic: {
                    required: function () {
                        return $('#Active').is(':checked');
                    }
                },
                CompanyIdentificationNumber: {
                    required: function () {
                        return $('#Active').is(':checked');
                    }
                },
                Address: {
                    required: function () {
                        return $('#Active').is(':checked');
                    }
                },
                City: {
                    required: function () {
                        return $('#Active').is(':checked');
                    }
                },
                PostalCode: {
                    required: function () {
                        return $('#Active').is(':checked');
                    }
                },
                Country: {
                    required: function () {
                        return $('#Active').is(':checked');
                    }
                }
            },             
            errorClass: "text-danger",
            errorElement: "span",
            submitHandler: (form) => {
                this.submitForm();
                return false;
            }
        });
        //$(this.formElement).validate({
        //    errorClass: 'is-invalid',
        //    validClass: 'is-valid',
        //    errorElement: 'div',
        //    errorPlacement: (error, element) => {
        //        error.addClass('invalid-feedback');
        //        element.after(error);
        //    },
        //    highlight: (element, errorClass, validClass) => {
        //        $(element).addClass(errorClass).removeClass(validClass);
        //        $(element).closest('.form-group').find('.invalid-feedback').show();
        //    },
        //    unhighlight: (element, errorClass, validClass) => {
        //        $(element).removeClass(errorClass).addClass(validClass);
        //        $(element).closest('.form-group').find('.invalid-feedback').hide();
        //    },
        //    submitHandler: (form) => {
        //        this.submitForm();
        //        return false;
        //    }
        //});
    }


    private setupEventListeners(): void {
        // Back button
        $(this.element).on('click', '.btn-back', (e) => {
            e.preventDefault();
            window.location.href = '/organizacije';
        });

        // Register business premise button
        $(this.element).on('click', '.btn-register-premise', (e) => {
            e.preventDefault();
            this.registerBusinessPremise();
        });  

        $("#ImageFile").on('change', (ev) => this.previewImage(ev));
    }

    private initializeTinyMCE(): void {
        const descriptionTextarea = this.element.querySelector('#Description') as HTMLTextAreaElement;
        if (descriptionTextarea) {
            tinymce.init({
                selector: '#Description',
                plugins: 'link table image',
                toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
                skin: 'oxide',
                content_css: 'default',
                height: 300
            });
        }
    }

    private setupImagePreview(): void {
        const imageFileInput = this.element.querySelector('#imageFileInput') as HTMLInputElement;
        const imagePreview = this.element.querySelector('#imagePreview') as HTMLDivElement;

        if (imageFileInput && imagePreview) {
            imageFileInput.addEventListener('change', (event) => {
                const input = event.target as HTMLInputElement;
                if (input.files && input.files[0]) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        imagePreview.innerHTML = `<img src="${e.target?.result}" alt="Preview" class="img-thumbnail" style="max-height: 200px;">`;
                    };
                    reader.readAsDataURL(input.files[0]);
                }
            });
        }
    }

    private submitForm(): void {
        this.loader.show();
        

        const form = $(this.formElement);             

        if (!$(this.formElement).valid()) {
            return;
        }

        //var valid = $(this.formElement).valid();
        //alert(valid)
        //this.loader.hide();
        //return;

        const formData = new FormData(this.formElement);
        
        $.ajax({
            url: this.formElement.action,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: (response) => {
                if (response.success) {
                    alert(response.message);
                    if (response.redirectUrl) {
                        window.location.href = response.redirectUrl;
                    }
                } else {
                    alert(response.message);
                }
            },
            error: (xhr) => {
                alert('Napaka pri shranjevanju podatkov.');
            },
            complete: () => {
                this.loader.hide();
            }
        });
    }

    private registerBusinessPremise(): void {
        const organizationId = this.formElement.querySelector('#Id')?.getAttribute('value');
        if (!organizationId) return;

        this.loader.show();

        $.post(`/organizacije/registriraj-poslovni-prostor/${organizationId}`)
            .done((response) => {
                if (response.success) {
                    this.showNotification('Poslovni prostor uspešno registriran!', true);
                    // Reload the page to reflect changes
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                } else {
                    this.showNotification(response.message || 'Napaka pri registraciji poslovnega prostora.', false);
                }
            })
            .fail((error) => {
                this.showNotification('Napaka pri registraciji poslovnega prostora.', false);
            })
            .always(() => {
                this.loader.hide();
            });
    }

    private showNotification(message: string, isSuccess: boolean): void {
        if (!this.notificationElement || !this.notificationMessageElement) return;

        this.notificationElement.classList.remove('alert-success', 'alert-danger');
        this.notificationElement.classList.add(isSuccess ? 'alert-success' : 'alert-danger');
        this.notificationMessageElement.textContent = message;
        this.notificationElement.style.display = 'block';

        // Auto-hide after 5 seconds
        setTimeout(() => {
            this.hideNotification();
        }, 5000);
    }

    private hideNotification(): void {
        if (this.notificationElement) {
            this.notificationElement.style.display = 'none';
        }
    }

    private previewImage(event:any):void {
        const input = event.target;
        const preview = document.getElementById('imagePreview');

        if (input.files && input.files[0] && preview!=null) {
            const reader = new FileReader();

            reader.onload = function (e) {
                preview.innerHTML = `<img src="${input.result}" alt="Predogled slike" style="max-width: 100%; height: auto;" />`;
            };

            reader.readAsDataURL(input.files[0]);
        } else {
            preview!.innerHTML = '';
        }
    }
   
}